module.exports = __webpack_public_path__ + "static/media/carrier_agreement_icon.85b85d28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/carrier_agreement_icon.svg
// module id = 727
// module chunks = 0